import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const SIDEBAR_CHAT_CREATION_OPTION = {
  DATA_IMPORT: 'data_import',
  NEW_CHAT: 'new_chat',
} as const;

export const LLM_CHAT_ANALYTICS_ACTIONS = {
  SUBMITTED_LLM_CHAT_REACTION_FEEDBACK: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_llm_chat_reaction_feedback',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SAVED_LLM_GENERATED_DOCUMENT: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'saved_llm_generated_document',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SENT_LLM_CHAT_MESSAGE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'sent_llm_chat_message',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_LLM_CHAT: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_llm_chat',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_SUGGESTED_ACTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_suggested_action',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_LLM_CHAT_FROM_SUGGESTED_ACTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'created_llm_chat_from_suggested_action',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  OPENED_LLM_CHAT_FROM_HISTORY: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_llm_chat_from_history',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_SIDEPANEL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_ai_sidepanel',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_AI_SIDEPANEL_HAMBURGER: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_ai_sidepanel_hamburger',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SELECTED_SIDEBAR_CHAT_CREATION_OPTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'selected_sidebar_chat_creation_option',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_TENANT_SETTINGS: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_ai_tenant_settings',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_ENABLE_BENCHLING_FOR_SLACK: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_enable_benchling_for_slack',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_DISABLE_BENCHLING_FOR_SLACK: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_disable_benchling_for_slack',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_ADD_TO_SLACK: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_add_to_slack',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_REMOTE_MCP_SERVER_CONFIG: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'updated_remote_mcp_server_config',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ENDED_COMPOSE_REALTIME_VOICE_SESSION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'ended_compose_realtime_voice_session',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  FOCUSED_START_CHAT_INPUT: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'focused_start_chat_input',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_START_CHAT_QUESTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_start_chat_question',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_GLOBAL_ENTRY_FROM_COMPOSE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_global_entry_from_compose',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_GLOBAL_ENTRY_FROM_COMPOSE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_global_entry_from_compose',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_AI_SETTINGS_PANEL: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'opened_ai_settings_panel',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SAVED_RESPONSE_PREFERENCES: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'saved_response_preferences',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_TEMPLATE_FROM_COMPOSE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_template_from_compose',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_SKILL_FROM_PLUS_MENU: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_skill_from_plus_menu',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SUBMITTED_AGENT_SKILL_ACCESS_CHANGES: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_agent_skill_access_changes',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_TEMPLATE_FROM_COMPOSE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_template_from_compose',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CREATED_CHAT_FOR_ENTRY: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'created_chat_for_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CREATED_CHAT_FOR_PIPELINE_STEP: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'created_chat_for_writing_pipelines_custom_code',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_ENTRY_ASSISTANT_CTA: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_entry_assistant_cta',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_ENTITY_ASK_BUTTON: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_entity_ask_button',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_ENTITY_ASK_BUTTON: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_entity_ask_button',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_INVENTORY_ASK_BUTTON: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_inventory_ask_button',
    actionCategory: ACTION_CATEGORY.READ,
  },

  // AI onboarding flow events
  CLICKED_ONBOARDING_BANNER_START: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_onboarding_banner_start',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_ONBOARDING_BANNER_DISMISS: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_onboarding_banner_dismiss',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  STARTED_ONBOARDING_FROM_SETTINGS: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'started_onboarding_from_settings',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  RESTARTED_ONBOARDING_FROM_SETTINGS: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'restarted_onboarding_from_settings',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLEARED_ONBOARDING_ABOUT_ME: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'cleared_onboarding_about_me',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_ONBOARDING_SCREEN: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_onboarding_screen',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DISMISSED_ONBOARDING_SCREEN: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'dismissed_onboarding_screen',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  COMPLETED_ONBOARDING: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'completed_onboarding',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_ONBOARDING_QUESTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_onboarding_question',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SKIPPED_ONBOARDING_QUESTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'skipped_onboarding_question',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  ANSWERED_ONBOARDING_QUESTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'answered_onboarding_question',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_ONBOARDING_INTEREST_QUESTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_onboarding_interest_question',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SELECTED_ONBOARDING_INTEREST_OPTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'selected_onboarding_interest_option',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SELECTED_ONBOARDING_CATEGORY_PROMPT: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'selected_onboarding_category_prompt',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  VIEWED_ONBOARDING_GEMINI_SUGGESTIONS: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_onboarding_gemini_suggestions',
    actionCategory: ACTION_CATEGORY.READ,
  },
  COMPLETED_ONBOARDING_FIRST_CHAT: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'completed_onboarding_first_chat',
    actionCategory: ACTION_CATEGORY.WRITE,
  },

  CLICKED_CREATE_DASHBOARD_FROM_QUERY: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_create_dashboard_from_query',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_ADD_QUERY_TO_EXISTING_DASHBOARD: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_add_query_to_existing_dashboard',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_CREATE_NEW_DASHBOARD_FROM_QUERY: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_create_new_dashboard_from_query',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_PROGRESSIVE_DISCLOSURE_CATEGORY: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_progressive_disclosure_category',
    actionCategory: ACTION_CATEGORY.READ,
  },
  HOVERED_PROGRESSIVE_DISCLOSURE_CATEGORY: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'hovered_progressive_disclosure_category',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // Which category pills the randomizer dealt, so runs can be attributed back to what was offered.
  VIEWED_PROGRESSIVE_DISCLOSURE_CATEGORIES: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'viewed_progressive_disclosure_categories',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLICKED_EXPLORE_USE_CASES: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'clicked_explore_use_cases',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SUBMITTED_PROGRESSIVE_DISCLOSURE_OPTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'submitted_progressive_disclosure_option',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  HOVERED_PROGRESSIVE_DISCLOSURE_OPTION: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'hovered_progressive_disclosure_option',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RAN_CHAT_USE_CASE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'ran_use_case',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  // A use case link that put its prompt in the composer without sending it. Deliberately separate
  // from RAN_CHAT_USE_CASE: a prompt the user never sent is not a run, but link traffic is
  // otherwise invisible, since nothing downstream of the click is attributable to the link.
  // Optional `campaign` (from utm_campaign) joins this prefill to a later run of the same campaign.
  PREFILLED_CHAT_USE_CASE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'prefilled_use_case',
    actionCategory: ACTION_CATEGORY.READ,
  },

  // Agent approval events
  ANSWERED_AGENT_APPROVAL_REQUEST: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'answered_agent_approval_request',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  UPDATED_AGENT_APPROVAL_STATE: {
    module: ANALYTICS_MODULE.LLM_CHAT,
    action: 'updated_agent_approval_state',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};
